import PropTypes from 'prop-types'
import { connectStateResults } from 'react-instantsearch-dom'
import { Box, Heading, Text } from '@redriverpress/system'

import { InfiniteHits } from 'Packages/search'

import VideosGrid from './VideosGrid'
import VideoCardHit from './VideoHit'

function VideosSearchResults({
  searchState,
  searchResults,
  userHasAccess,
  userLoggedIn,
}) {
  const nbHits = searchResults && searchResults.nbHits
  const { query } = searchState

  return (
    <Box as='section'>
      {searchResults && (
        <Box mb={4}>
          <Heading as='h3' mb={2}>
            Search results
          </Heading>
          <Text>
            {nbHits?.toLocaleString()} match{nbHits !== 1 && 'es'} for{' '}
            <Text as='span' fontWeight={600}>
              {query}
            </Text>
          </Text>
        </Box>
      )}
      <InfiniteHits
        hitComponent={VideoCardHit}
        hitsWrapper={VideosGrid}
        hitComponentProps={{
          userHasAccess,
          userLoggedIn,
        }}
      />
    </Box>
  )
}

VideosSearchResults.defaultProps = {
  searchResults: null,
}

VideosSearchResults.propTypes = {
  searchState: PropTypes.shape({
    query: PropTypes.string,
  }).isRequired,
  searchResults: PropTypes.shape({
    nbHits: PropTypes.number,
  }),
  userHasAccess: PropTypes.bool.isRequired,
  userLoggedIn: PropTypes.bool.isRequired,
}

export default connectStateResults(VideosSearchResults)
